import { object } from 'yup';

import { mandatoryErrMessage } from '@constants/validationConstants';

export const autoSwitchSchema = object({
	lastVesTimePeriod: object()
		.nullable()
		.required(mandatoryErrMessage('Time interval')),
	netconfCheckTimePeriod: object()
		.nullable()
		.required(mandatoryErrMessage('Time interval')),
});
